import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import Text from '../../../../../General/Text';
import Button from '../../../../../General/Button';
import {
  ContainerStyled,
  ContentStyled,
  CreditLimitMessageStyled,
  DisabledWebpayStyled,
  HandleStyled,
  HeaderStyled,
  InfoIconStyled,
  TextInvoice,
  TextStyled,
} from './style/MethodStyled';
import { GoogleTagManager } from '../../../../../../helpers';
import useOtherLines from '../../../../../../hooks/useOtherLines';
import { InfoIcon } from '../../../../../../images/mis-otras-lineas';
import { LoadingButton } from '../../../../../OtherLines/OtherLinesSidePanel/styles/OtherLinesSidePanelStyles';
import ButtonLoading from '../../../../../General/ButtonLoading';

const InvoiceMethod = ({ buyCallback, disabled }) => {
  const {
    isOtherLines,
    setPaymentType,
    paymentType,
    actionType,
  } = useOtherLines();
  const [toggled, setToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const clickHandler = () => {
    if (!disabled) setToggle(!toggled);
  };

  useEffect(() => {
    if (paymentType === 'factura') {
      buyCallback('CONTRAFACTURA-OTRAS-LINEAS');
    }

    return setPaymentType('');
  }, [paymentType]);

  const buyHandler = () => {
    setIsLoading(true);
    if (isOtherLines) {
      setPaymentType('factura');
      GoogleTagManager.tagInteractiveEvent({
        eventCategory: 'Home',
        eventAction: 'Pago en boleta',
        eventTag: 'BTN_COMPRAR_BOLSA_CONTRAFACTURA_OTRAS_LINEAS',
      });
    } else {
      buyCallback('CONTRAFACTURA');
      GoogleTagManager.tagInteractiveEvent({
        eventCategory: 'Home',
        eventAction: 'Pago en boleta',
        eventTag: 'BTN_COMPRAR_BOLSA_BOLETA',
      });
    }
  };

  return (
    <>
      <ContainerStyled disabled={disabled}>
        <HeaderStyled>
          <TextStyled>
            <TextInvoice disabled={disabled}>
              Pagar en próxima boleta
            </TextInvoice>
          </TextStyled>
          <HandleStyled
            data-testid="toggle-handler"
            onClick={clickHandler}
            toggled={toggled}
            disabled={disabled}
          />
        </HeaderStyled>
        <AnimatePresence initial={false}>
          {toggled && (
            <ContentStyled
              data-testid="toggle-content"
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: 'auto' },
                collapsed: { opacity: 0, height: 0 },
              }}
              transition={{ duration: 0.3 }}
            >
              {isLoading ? (
                <LoadingButton>
                  <ButtonLoading />
                </LoadingButton>
              ) : (
                <Button
                  color="bubbleGum"
                  maxWidth="100%"
                  click={buyHandler}
                  margin="20px 0px"
                  disabled={disabled}
                >
                  PAGAR
                </Button>
              )}
              <DisabledWebpayStyled>
                <InfoIcon />
                <Text
                  text={`El costo de esta ${
                    isOtherLines ? actionType : 'bolsa'
                  } se te cobrará en tu próxima boleta mensual`}
                  color="#B3A6BA"
                  size="13px"
                  weight="400"
                />
              </DisabledWebpayStyled>
            </ContentStyled>
          )}
        </AnimatePresence>
      </ContainerStyled>
      {disabled && (
        <CreditLimitMessageStyled>
          <InfoIconStyled />
          <p>Has alcanzado el máximo de crédito permitido para tu cuenta.</p>
        </CreditLimitMessageStyled>
      )}
    </>
  );
};

InvoiceMethod.propTypes = {
  buyCallback: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default InvoiceMethod;
